import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcademicLandingPageComponent } from './academic-landing-page/academic-landing-page.component';
import { AcademiclinkComponent } from './academiclink/academiclink.component';

const routes: Routes = [

  {
    path:'',component:AcademiclinkComponent,
    children:[
      {
        path:'AcademicCounsel',component: AcademicLandingPageComponent,
        
      },
    
    ]

  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AcademicFormRoutingModule { }
